export default "Les collectivités peuvent obtenir des primes CEE pour rénover leur patrimoine bâti (mairies, gymnases, écoles). Calculez vos droits et montez votre dossier CEE collectivités.";
